import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
	button: {
		fontSize: theme.typography.pxToRem(13),
		backgroundColor: '#363636',
		border: 0,
		'&:hover': {
			cursor: 'pointer',
			backgroundColor: '#262626',
			textDecoration: 'none',
		},
	},
	error: {
		display: 'grid',
		gridTemplateColumns: '200px repeat(6, 125px)',
		rowGap: '10px',
	},
	card: {
		flexDirection: 'column',
		marginBottom: theme.spacing(1),
		backgroundColor: theme.palette.background.paper,
	},
	cardBtn: {
		justifyContent: 'flex-end',
		alignSelf: 'center',
	},
	vestibular: {
		fontWeight: 500,
	},
	infoVestibular: {
		display: 'grid',
		gridTemplateColumns: '325px repeat(3, 125px)',
	},
	item: {
		color: '#8190A7',
	},
	reportRow: {
		display: 'flex',
		flexDirection: 'row',
		paddingLeft: 20,
	},
	reportLabel: {
		fontSize: 14,
		fontWeight: 'lighter',
		marginRight: 10,
	},
	reportText: {
		fontSize: 13,
		marginRight: 10,
		color: 'red',
	},
}));
